(() => {
  window.dataLayer = window.dataLayer || [];

  document.addEventListener('click', (event) => {
    const phoneLink = event.target.closest('a[href^="tel:"]');
    if (phoneLink) {
      window.dataLayer.push({
        event: 'phone_call_click',
        phone_number: phoneLink.getAttribute('href').replace('tel:', ''),
      });
      return;
    }

    const downloadButton = event.target.closest('#calculator-app button[name="download"]');
    if (downloadButton) {
      window.dataLayer.push({ event: 'download_inventory' });
    }
  });

  document.addEventListener('submit', (event) => {
    if (event.target?.id === 'ContactForm') {
      window.dataLayer.push({ event: 'generate_lead', form_id: 'ContactForm' });
    }
  });
})();
